import * as React from 'react';
import { memo } from 'react';

export type SpacerProps = {
	size: 's' | 'm' | 'l' | 'xl';
};

const Spacer = ({ size }: SpacerProps) => <div className={`h-spacer${size ? ` h-spacer--${size}` : ''}`} />;

export { Spacer };
export default memo(Spacer, (prevProps, nextProps) => {
	return prevProps.size === nextProps.size;
});
